import React from 'react';
import { motion } from 'framer-motion';
import clinicalTrials from '../img/Clinical trials vert.png';

const ClinicalValidationSection = () => {
  return (
    <section id="clinical" className="py-20 md:py-32 relative bg-ninsun-surface border-y border-gray-200">
      <div className="container mx-auto px-6">
        
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h2 className="text-4xl md:text-5xl font-display font-bold text-ninsun-text mb-6 tracking-tight">Clinically Validated</h2>
            <p className="text-ninsun-muted leading-relaxed">
              A first clinical study including more than 245 patients whose samples were mostly supplied by the Lung Biobank, Lyon University Hospitals, France, with non-small cell lung cancer demonstrated the prognostic value of the NinStem Lung assay.
            </p>
            <p className="text-ninsun-muted leading-relaxed">
              Detection of Cancer Stem Cells in high abundance in tumor using the validated glycan-based signature was associated with poorer clinical outcomes, including reduced overall survival and increased risk of disease progression. These findings confirm the clinical relevance of Cancer Stem Cell detection and support its potential utility for improved patient stratification in lung cancer immunotherapy.
            </p>
            <div className="glass-panel p-6 rounded-xl border-l-4 border-l-ninsun-gold mt-6">
              <p className="text-ninsun-text font-semibold italic">
                The predictive value of NinStem Lung is now being evaluated in a preliminary retrospective clinical study led by Pr. Nicolas GIRARD, Head of Medical Oncology, Institut Curie, Paris, France.
              </p>
            </div>
            <div className="pt-6">
              <p className="text-ninsun-muted font-bold">
                You are a clinician and want to learn more about our solution? <br/>
                <a href="mailto:contact@ninsun-biotech.com" className="text-ninsun-gold hover:underline font-bold">Contact us</a>
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <img 
              src={clinicalTrials}
              alt="Clinical validation study graph"
              className="rounded-2xl shadow-lg w-full h-auto border border-gray-200"
            />
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default ClinicalValidationSection;